export default __webpack_public_path__ + "static/4-pick-location-e8955804de08ac324b97e4c471a44db8.png";